<template>
  <div>
    <nav
      class="navbar navbar-expand-lg align-items-lg-center container-p-x bg-navbar-theme fixed-top"
    >
      <div class="container">
        <router-link
          :to="home"
          class="navbar-brand app-brand"
        >
          <img
            src="@/common/assets/img/logo.png"
            class="img-navbar"
            alt="logo"
          >
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          @click="toggleDropdown()"
        >
          <i class="toggle-icon fa fa-times text-cr-red" v-if="showDropdown"></i>
          <i class="toggle-icon fa fa-bars" v-else></i>
        </button>
        <div class="navbar-collapse collapse">
          <hr class="d-lg-none w-100 my-2">

          <div class="navbar-nav align-items-lg-center ml-auto">
            <div class="d-flex align-items-center" v-if="!authTokenExists">
              <div class="demo-navbar-notifications nav-item dropdown">
                <a
                  href="https://commercialreview.nl/bedrijven/"
                  target="_blank"
                  class="nav-link hide-arrow"
                >
                  {{ $t('phrase.for_companies') }}
                </a>
              </div>
              <div class="border-dark">
                <a
                  href="https://commercialreview.nl/over-ons/"
                  target="_blank"
                  class="nav-link hide-arrow mr-5"
                >
                  {{ $t('phrase.about_us') }}
                </a>
              </div>

              <div class="demo-navbar-notifications nav-item dropdown mr-lg-3">
                <v-button
                  id="button-to-register-commercial"
                  text="phrase.register_commercial"
                  style-type="danger text-white"
                  :route-to="{name: 'public-register-commercial'}"
                  icon="plus"
                />
              </div>

              <div class="nav-item dropdown mr-lg-3">
                <router-link
                  id="button-to-login"
                  class="btn btn-primary"
                  :to="{name: 'login'}"
                >
                  {{ $t('word.login') }}
                </router-link>
              </div>
            </div>
            <div class="d-flex align-items-center" v-else>
              <v-coin-account-progress-bar
                @click="$router.push({name: 'reviewer-dashboard'})"
              />

              <div
                class="nav-item dropdown"
                id="top-navbar-dropdown"
              >
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  @click.prevent="toggleDropdown()"
                  v-click-outside="hideDropdown"
                >
                  <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                    <img
                      v-if="user.isAuthenticated && user.profile.picture"
                      :src="user.profile.picture"
                      alt=""
                      class="d-block img-avatar rounded-circle"
                    />
                    <img
                      v-else
                      src="@/common/assets/img/anonymous.svg"
                      alt=""
                      class="d-block img-avatar rounded-circle"
                    />
                    <span class="ml-2 ml-lg-0 d-none d-xl-block text-username">
                      {{ user.full_name_or_username }}
                    </span>
                  </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" :class="{'d-block': showDropdown}">
                  <router-link
                    class="dropdown-item"
                    :to="{name: 'user-profile'}"
                  >
                    <i class="fa fa-user text-light mr-2"></i> {{ $t('phrase.my_account') }}
                  </router-link>

                  <router-link
                    class="dropdown-item"
                    :to="{name: 'organisation-dashboard'}"
                    v-if="org"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        v-if="org.logo"
                        :src="org.logo"
                        class="img-thumbnail img-navbar-mini mr-2"
                        alt="logo"
                      />

                      <i v-else class="fa fa-building text-light mr-2"></i> &nbsp;{{ org.name }}
                      <div class="ml-2 badge badge-pill badge-warning" v-if="!org.isVerified">
                        {{ $t('phrase.not_active_yet').toLocaleLowerCase() }}
                      </div>
                    </div>
                  </router-link>
                  <div class="dropdown-divider"></div>

                  <router-link
                    class="dropdown-item"
                    :to="{ name: 'admin-dashboard' }"
                    v-if="user.su"
                  >
                    <i class="fa fa-database text-light mr-2"></i> {{ $t('word.admin') }}
                  </router-link>
                  <div class="dropdown-divider" v-if="user.su"></div>
                  <a
                    id="top-navbar-logout"
                    :href="getBackendUrl('/auth/logout/')"
                    class="dropdown-item"
                  >
                    <i class="fa fa-power-off text-danger mr-2"></i> &nbsp;
                    {{ $t('word.logout') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <transition name="fade-up">
      <v-mobile-nav
        v-if="showDropdown"
        @close="showDropdown = false"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import CoinAccountProgressBar from '@/common/components/coins/CoinAccountProgressBar.vue';
import MobileNav from '@/reviewer/components/MobileNav.vue';
import Button from '@/common/components/Button.vue';
import { getBackendUrl } from '@/common/utils/api';

export default {
  name: 'TopNavbar',
  components: {
    'v-coin-account-progress-bar': CoinAccountProgressBar,
    'v-mobile-nav': MobileNav,
    'v-button': Button,
  },
  computed: {
    ...mapGetters([
      'authTokenExists',
      'org',
      'user',
    ]),
    home() {
      if (this.user.isAuthenticated) {
        return { name: 'dashboard' };
      }
      return { name: 'home' };
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  directives: {
    'click-outside': ClickOutside,
  },
  methods: {
    getBackendUrl,
    hideDropdown() {
      if (window.innerWidth > 991) {
        // Only happens on large screens;
        this.showDropdown = false;
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};
</script>

<style scoped>
img.img-navbar {
  height: 50px;
  width: 179px;
}

.img-navbar-mini {
  width: 15px;
  height: auto;
}

.text-username {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.img-avatar {
  width: 30px !important;
  height: auto;
  margin-left: 8px;
  margin-right: 8px;
}

.toggle-icon {
  font-size: 20px;
}
</style>
